/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../ManagePoi/ManagePoi.scss';

import { updateHotel, deleteHotel, saveHotel } from '../../../../../actions/postGeoData';

const fastStyleMargin = {
  marginTop: '7px',
};

const fullWidth = {
  width: '100% !important',
};

const propertyNames = ["id", "typ", "nazwa_pelna", "opis", "opis_pelny", "wlasnosc", "jezyk",
  "miejscowosc", "ulica", "nr_budynku", "nr_lokalu", "kod_pocztowy", "dlugosc_geogr", "szerokosc_geogr",
  "telefon", "email", "strona_www", "symbol", "licz_miejsc_nocleg", "liczba_pokoi", "pokoje_jednoos_licz",
  "pokoje_jednoos_cena", "pokoje_dwuos_licz", "pokoje_dwuos_cena", "pokoje_trzyos_licz", "pokoje_trzyos_cena",
  "pokoje_czteroos_licz", "pokoje_czteroos_cena", "pokoje_piecioos_licz", "pokoje_piecioos_wieksz_cena",
  "apartamenty_licz", "apartamenty_cena", "rodzaje_pokoi", "caloroczny_sezonowy", "godz_zakwaterowania",
  "godz_wykwaterowania", "godz_pracy_recepc", "dodatk_recepcja", "podst_udogod", "podst_dla_gosci",
  "zdrowie_relaks", "wyzywienie", "dodatk_wyzywienie", "sport_rozrywka", "rodzina_dzieci", "biznes", "uslugi",
  "motoryzacyjne", "inne_udogod_uslugi", "x", "geom", "y", "nu_id"
];
const propertyDisplayableNames = ["id", "Typ", "Nazwa pełna", "Opis", "Opis pełny", "Własność", "Język",
  "Miejscowość", "Ulica", "Numer budynku", "Numer lokalu", "Kod pocztowy", "Długość geogr", "Szerokość geogr",
  "Telefon", "E-mail", "Strona www", "Symbol", "Liczba miejsc noclegowych", "Liczba pokoi",
  "Pokoje jednoosobowe - liczba", "Pokoje jednoosobowe - cena", "Pokoje dwuosobowe liczba",
  "Pokoje dwuosobowe - cena", "Pokoje trzyosobwe liczba", "Pokoje trzyosobowe - cena",
  "Pokoje czteroosobowe - liczba", "Pokoje czteroosobowe - cena", "Pokoje pięcioosobowe - liczba",
  "Pokoje pięcioosobowe większe - cena", "Apartamenty - liczba", "Apartamenty - cena", "Rodzaje pokoi",
  "Całoroczny sezonowy", "Godzina zakwaterowania", "Godzina wykwaterowania", "Godziny pracy recepcji",
  "Dodatkowa recepcja", "Podstawowe udogodnienia", "Podst dla gości", "Zdrowie relaks", "Wyżywienie",
  "Dodatkowe wyżywienie", "Sport rozrywka", "Rodzina dzieci", "Biznes", "Usługi",
  "Motoryzacyjne", "Inne udogodnienia usługi", "x", "geom", "y", "nu_id"];
const notAllowedIndexes = [0, 12, 13, 52, 51, 50, 49]

class ManageHotel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editedFeatures: [],
    };
  }

  deleteFeature = (id) => {
    this.props.deleteHotel(this.props.district.prefix, id)
      .then(resp => {
        console.info("pomyślnie usunięto hotel");
      });
  }
  editFeature = (feature) => {
    let mappedFeature = {};
    feature.properties.map((v, i) => {
      mappedFeature[propertyDisplayableNames[i]] = v;
    });
    let currentState = this.state.editedFeatures.slice();
    _.map(currentState, 'id').indexOf(mappedFeature.id) >= 0 ? currentState.pop(mappedFeature) : currentState.push(mappedFeature);
    this.setState({ editedFeatures: currentState });
  }
  acceptFeature = (id) => {
    this.props.saveHotel(this.props.district.prefix, id)
  }
  saveFeatureEditFeature = (feature) => {
    let rewritedFeatureKeys = {}
    for (const i in Object.keys(feature)) {
      const key = Object.keys(feature)[i];
      const val = feature[key];
      rewritedFeatureKeys[propertyNames[i]] = val;
    }
    this.props.updateHotel(this.props.district.prefix, rewritedFeatureKeys)
      .then(resp => {
        let currentState = this.state.editedFeatures.slice();
        currentState.pop(feature);
        this.setState({ editedFeatures: currentState });
      });
  }

  onEditFeature = (e, feature, property) => {
    feature[property] = e.target.value;
    let currentState = this.state.editedFeatures.slice();
    currentState.pop(_.find(currentState, (o) => o.id === feature.id));
    currentState.push(feature);
    this.setState({ editedFeatures: currentState });
  }

  render() {
    return this.props.new_hotels.data ? (
      <div className="col-xs-12">
        <div className="row">
          <div className="col-sm-4">Typ</div>
          <div className="col-sm-4">Pełna nazwa</div>
          <div className="col-sm-4">Akcje</div>
          <hr className="style-one" />
        </div>
        {this.props.new_hotels.data.features.map((value) => {
          let feature = _.find(this.state.editedFeatures, (o) => o.id === value.properties[0]);
          return (
            <div className="row" key={value.properties[0]}>
              <div className="col-sm-12">
                <div className="col-sm-3">{value.properties[1]}</div>
                <div className="col-sm-3">{value.properties[2]}</div>
                <div className="col-sm-3">{value.properties[3]}</div>

                {/* buttons should be visible only when we're not editing feature */}
                {!feature ? (
                  <div className="col-sm-3">
                    <button type="button" className="btn btn-danger" onClick={() => this.deleteFeature(value.properties[0])}>Usuń</button>
                    <button type="button" className="btn btn-warning" onClick={() => this.editFeature(value)}>Edytuj</button>
                    <button type="button" className="btn btn-primary" onClick={() => this.acceptFeature(value.properties[0])}>Akceptuj</button>
                  </div>
                ) : <div className="col-sm-3" />}

              </div>
              <div className={_.map(this.state.editedFeatures, 'id').indexOf(value.properties[0]) >= 0 ? 'col-sm-12' : 'dont-display-feature-edition'}>
                <div className="row">
                  <div className="col-sm-12">
                    <hr className="style-two" />
                  </div>
                  {value.properties.map((v, i) => {

                    return feature && notAllowedIndexes.indexOf(i) === -1 ? (
                      <div className="col-sm-12" key={i}>
                        <div className="form-group">
                          <label className="control-label col-xs-2">{Object.keys(feature)[i]}</label>
                          <div className="col-xs-6">
                            <input
                              className="form-control"
                              name={Object.keys(feature)[i]}
                              onChange={(e) => this.onEditFeature(e, feature, Object.keys(feature)[i])}
                              value={feature[Object.keys(feature)[i]] ? feature[Object.keys(feature)[i]] : ''}
                            />
                          </div>
                        </div>
                      </div>
                    ) : null;
                  })}
                  <div className="col-xs-4">
                    <button type="button" className="btn btn-danger" onClick={() => this.editFeature(value)}>Anuluj</button>
                    <button type="button" className="btn btn-primary" onClick={() => this.saveFeatureEditFeature(feature)}>Zapisz zmiany</button>
                  </div>
                </div>
              </div>
              <div className="col-sm-12">
                <hr className="style-two" />
              </div>
            </div>
          );
        })}
      </div>
    ) : <h3>Brak zgłoszonych hoteli lub noclegów</h3>;
  }
}

const mapState = (state) => ({
  district: state.district.district,
  new_hotels: state.postGeoData.additionalLayers.hotels_propozycje,
});
const mapDispatch = {
  updateHotel,
  deleteHotel,
  saveHotel,
};

export default withStyles(s)(connect(mapState, mapDispatch)(ManageHotel));



// WEBPACK FOOTER //
// src/components/Modals/Settings/Panels/ManageHotel/ManageHotel.js